import React, { Component } from 'react';
import * as $ from 'jquery';
import Signup from './Signup.js';
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';
import axios from 'axios';
import spinner from '../../images/loading-spinner.gif';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

let cancelToken;

class SignupContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    $(window).off("resize", this.resize);
  }

  componentDidMount() {
    $(window).resize(this.resize);
    this.resize();
    this.reload();
  }

  componentWillReceiveProps() {
    $('#content')[0].scrollIntoView();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  confirmSignup = (params) => {
    this.props.post(
      "/confirmSignup",
      params,
      this.didSignup,
      (error) => {
        this.setState({ toDashboard: true });
        this.props.handleErrorResponse(error);
      },
      cancelToken
    );
  }

  didSignup = () => {
    this.setState({ confirmed: true });
  }

  getInitState = () => {
    return {
      confirmed: false,
      toDashboard: false
    };
  }

  reload = () => {
    this.confirmSignup({
      token_id: this.props.getTokenId(),
      token_signup: this.props.match.params.token_signup
    });
  }

  resize = () => {
    $('#content').css({
      paddingTop: this.props.getNavbarHeight()
    });
  }

  renderSignup = () => {
    return(
      <Signup />
    );
  }

  renderFooter = () => {
    return(
      <Footer />
    );
  }

  renderNavbar = () => {
    return(
      <Navbar
        handleLanguageChange={this.props.handleLanguageChange}
        lang={this.props.lang} />
    );
  }

  render() {
    const { t } = this.props;

    if (this.state.toDashboard) {
      return <Redirect to="/events" />;
    }

    return(
      <div>
        {this.renderNavbar()}
        <div className="container-fluid" id="content">
          {!this.state.confirmed &&
            <div className="container-padding text-center">
              <img
                width="100px"
                height="100px"
                alt={t('guest.signup.img_spinner')}
                src={spinner} />
            </div>
          }
          {this.state.confirmed && this.renderSignup()}
        </div>
        {this.renderFooter()}
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(SignupContainer);



// WEBPACK FOOTER //
// ./src/guest/signup/SignupContainer.js